import React from 'react';
import { OverviewComponentType, ProductOverviewRegistry } from '../../types';
import ReachScorecard from '@containers/ValueCreationMetrics/Manufacturing/IPC/ValueRealization/ReachScorecard';
import SummaryScorecard from '@containers/ValueCreationMetrics/Manufacturing/IPC/ValueRealization/SummaryScorecard';
import { ValueRealizationProvider } from '@containers/ValueCreationMetrics/Manufacturing/IPC/ValueRealization/ValueRealizationContext';

const scorecards: OverviewComponentType[] = [
  () => <ReachScorecard showTableView={false} />,
  () => (
    <ValueRealizationProvider>
      <SummaryScorecard isOverviewMode={true} />
    </ValueRealizationProvider>
  ),
];

const ipcRegistry: ProductOverviewRegistry = {
  scorecards,
};

export default ipcRegistry;
